import type { RequestQueryParams } from "@/lib/http-client";
import type { ConnectedUsersFilters } from "./search";

/**
 * The engine matches `user_id` and `provider_id` exactly, so each is sent
 * whole (trimmed) or not at all.
 */
export function connectedUsersQueryParams({
  userId,
  providerId,
}: ConnectedUsersFilters): RequestQueryParams {
  const user = userId.trim();
  const provider = providerId.trim();
  return {
    ...(user !== "" && { user_id: user }),
    ...(provider !== "" && { provider_id: provider }),
  };
}

export function countActiveFilters(filters: ConnectedUsersFilters): number {
  return Object.keys(connectedUsersQueryParams(filters)).length;
}
